import { render, staticRenderFns } from "./edit-quiz.html?vue&type=template&id=4f864a95&scoped=true&"
import script from "./edit-quiz.js?vue&type=script&lang=js&"
export * from "./edit-quiz.js?vue&type=script&lang=js&"
import style0 from "./edit-quiz.scss?vue&type=style&index=0&id=4f864a95&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f864a95",
  null
  
)

export default component.exports